import React, { useState } from 'react';
import { IoMdArrowDropdown } from "react-icons/io";
import { useTranslation } from 'react-i18next';

import circulerIcon from '../../assets/images/circulerIcon.png';

const LanguageTranslation = ({ className }) => {
    const { i18n } = useTranslation();

    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [languageName, setLanguageName] = useState(i18n.language === 'ar' ? 'AR' : i18n.language === 'fre' ? 'FRE' : 'EN');

    const toggleDropdown = () => {
        setDropdownVisible(!dropdownVisible);
    };

    const languageSelectHandler = (lang) => {

        if (lang === 'en') {
            i18n.changeLanguage(lang);
            setLanguageName('EN');
        } else if (lang === 'ar') {
            i18n.changeLanguage(lang);
            setLanguageName('AR');
        } else if (lang === 'fre') {
            i18n.changeLanguage(lang);
            setLanguageName('FRE');
        } else if (lang === 'es') {
            i18n.changeLanguage(lang);
            setLanguageName('ES');
        } else if (lang === 'ir') {
            i18n.changeLanguage(lang);
            setLanguageName('IR');
        } else if (lang === 'cn') {
            i18n.changeLanguage(lang);
            setLanguageName('CN');
        } else if (lang === 'vt') {
            i18n.changeLanguage(lang);
            setLanguageName('VT');
        } else if (lang === 'th') {
            i18n.changeLanguage(lang);
            setLanguageName('TH');
        } else if (lang === 'ru') {
            i18n.changeLanguage(lang);
            setLanguageName('RU');
        } else if (lang === 'it') {
            i18n.changeLanguage(lang);
            setLanguageName('IT');
        } else if (lang === 'tr') {
            i18n.changeLanguage(lang);
            setLanguageName('TR');
        }

    };

    return (
        <div className={`dropdown `}>
            <button onClick={toggleDropdown} className={`languageButton border-0 text-center`}>
                <img src={circulerIcon} alt='' width='15px' height='15px' className='me-2 rounded-1' />
                {languageName}
                <IoMdArrowDropdown className='ms-2' />
            </button>
            {dropdownVisible && (
                <div id="myDropdown1" className="dropdown-content">
                    <div className='d-flex align-items-center justify-content-center' onClick={() => { languageSelectHandler('en'); toggleDropdown() }}>
                        {/* <img src={britishFlag} alt='' width='28px' height='20px' className='me-2' /> */}
                        English
                    </div>
                    <div className='d-flex aling-items-center justify-content-center' onClick={() => { languageSelectHandler('ar'); toggleDropdown() }}>
                        {/* <img src={uaeFlag} alt='' width='25px' className='me-2' /> */}
                        Arabic
                    </div>
                    <div className='d-flex align-items-center justify-content-center' onClick={() => { languageSelectHandler('fre'); toggleDropdown() }}>
                        {/* <img src={franceFlag} alt='' width='28px' height='20px' className='me-2 rounded-1' /> */}
                        French
                    </div>
                    <div className='d-flex align-items-center justify-content-center' onClick={() => { languageSelectHandler('es'); toggleDropdown() }}>
                        {/* <img src={franceFlag} alt='' width='28px' height='20px' className='me-2 rounded-1' /> */}
                        Spanish
                    </div>
                    <div className='d-flex align-items-center justify-content-center' onClick={() => { languageSelectHandler('ir'); toggleDropdown() }}>
                        {/* <img src={franceFlag} alt='' width='28px' height='20px' className='me-2 rounded-1' /> */}
                        Persion
                    </div>
                    <div className='d-flex align-items-center justify-content-center' onClick={() => { languageSelectHandler('cn'); toggleDropdown() }}>
                        {/* <img src={franceFlag} alt='' width='28px' height='20px' className='me-2 rounded-1' /> */}
                        Chinese
                    </div>
                    <div className='d-flex align-items-center justify-content-center' onClick={() => { languageSelectHandler('vt'); toggleDropdown() }}>
                        {/* <img src={franceFlag} alt='' width='28px' height='20px' className='me-2 rounded-1' /> */}
                        Vietnamese
                    </div>
                    <div className='d-flex align-items-center justify-content-center' onClick={() => { languageSelectHandler('th'); toggleDropdown() }}>
                        {/* <img src={franceFlag} alt='' width='28px' height='20px' className='me-2 rounded-1' /> */}
                        Thai
                    </div>
                    <div className='d-flex align-items-center justify-content-center' onClick={() => { languageSelectHandler('ru'); toggleDropdown() }}>
                        {/* <img src={franceFlag} alt='' width='28px' height='20px' className='me-2 rounded-1' /> */}
                        Russian
                    </div>
                    <div className='d-flex align-items-center justify-content-center' onClick={() => { languageSelectHandler('it'); toggleDropdown() }}>
                        {/* <img src={franceFlag} alt='' width='28px' height='20px' className='me-2 rounded-1' /> */}
                        Italian
                    </div>
                    <div className='d-flex align-items-center justify-content-center' onClick={() => { languageSelectHandler('tr'); toggleDropdown() }}>
                        {/* <img src={franceFlag} alt='' width='28px' height='20px' className='me-2 rounded-1' /> */}
                        Turkish
                    </div>
                </div>
            )}
        </div>
    )
}

export default LanguageTranslation
